import { render, staticRenderFns } from "./DiaobodanForm.vue?vue&type=template&id=6ea2d41b&scoped=true&"
import script from "./DiaobodanForm.vue?vue&type=script&lang=js&"
export * from "./DiaobodanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2d41b",
  null
  
)

export default component.exports